define('shared/initializer/form/adapters/mixins/MemberFieldMapping',[
    '../../constants', 
    'shared/lib/RSVP',
    'shared/util/fields/common',
    'shared/util/fields/Telephone'
], 
function (
    constants, 
    RSVP, 
    fieldUtil,
    TelephoneUtil
) {
    
    'use strict';

    function Ctor() {

    }

    var p = Ctor.prototype;

    p.doBeforeSubmit = function(){
        var me = this;

        return RSVP.resolve()
        .then(function(){
                var targetFieldName = constants.FIELD.MemberHomePhone;
                var fieldPhoneType =  me.items[constants.FIELD.PHONE_TYPE];
                if(fieldPhoneType && TelephoneUtil.getCurrentPhoneType(fieldPhoneType.$el) == constants.PhoneType.Mobile){
                    targetFieldName = constants.FIELD.MemberMobilePhone;
                }
                fieldUtil.copyField(constants.FIELD.PHONE, targetFieldName, me.$form);

                fieldUtil.copyField(constants.FIELD.FirstName, constants.FIELD.MemberFirstName, me.$form);
                fieldUtil.copyField(constants.FIELD.LastName, constants.FIELD.MemberLastName, me.$form);
                fieldUtil.copyField(constants.FIELD.Email, constants.FIELD.MemberEmail, me.$form);
                fieldUtil.copyField(constants.FIELD.PASSWORD, constants.FIELD.MemberPassword, me.$form);
                fieldUtil.copyField(constants.FIELD.ETAG, constants.FIELD.MemberEtag, me.$form);
                fieldUtil.copyField(constants.FIELD.LANGUAGE, constants.FIELD.MemberLanguageCode, me.$form);
                fieldUtil.copyField(constants.FIELD.COUNTRY, constants.FIELD.MemberCountryCode, me.$form);
                fieldUtil.copyField(constants.FIELD.PARTNER, constants.FIELD.MemberPartner, me.$form);
                fieldUtil.copyField(constants.FIELD.OMNITURE_NAME, constants.FIELD.MemberOmnitureFriendlyName, me.$form);
                fieldUtil.copyField(constants.FIELD.smsnotification, constants.FIELD.MemberSubscribeToSMS, me.$form);
                fieldUtil.copyField(constants.FIELD.EFID, constants.FIELD.MemberEFID, me.$form);
                fieldUtil.copyField(constants.FIELD.HasOffersTransactionId, constants.FIELD.MemberHasOffersTransactionId, me.$form);
                fieldUtil.copyField(constants.FIELD.GoogleClickId, constants.FIELD.MemberGoogleClickId, me.$form);
                fieldUtil.copyField(constants.FIELD.MarinClickId, constants.FIELD.MemberMarinClickId, me.$form);
                fieldUtil.copyField(constants.FIELD.OnSuccessUrl, constants.FIELD.MemberOnSuccessUrl, me.$form);
                fieldUtil.copyField(constants.FIELD.TradeDoublerUId, constants.FIELD.MemberTradeDoublerUId, me.$form);
                fieldUtil.copyField(constants.FIELD.Age, constants.FIELD.MemberAge, me.$form);

                var traditionalEEField = me.items.get(constants.FIELD.EMAIL_ENGLISH);
                if(traditionalEEField && traditionalEEField.$el){
                    if(traditionalEEField.$el.is(':checked'))
                        fieldUtil.setFieldValue('true', constants.FIELD.MemberSubscribeToEmailEnglish, me.$form);
                    else
                        fieldUtil.setFieldValue('true', constants.FIELD.MemberSubscribeToETPromo, me.$form);
                }
        });
    };

    return Ctor;
});
